import { forwardRef, useEffect, useImperativeHandle, useRef, useState } from "react";
import { MdKeyboardDoubleArrowRight } from "react-icons/md";
import { Howl } from "howler";
import cardsdropping_snd from "../../../../../../assets/sounds/carddroping.mp3";
import gsap from "gsap";
import resultCards from "../../jacksorbetter/resultCards";
import emtyCard from "../../../../../../assets/games/blackjack/emtyCardBk.svg";

import "../../blackjack/blackjackIndex.css"



let dealerCard_old = [];
let playerCards_old = [];

let playerCards_split1_old = [];
let playerCards_split2_old = [];
let playerCards_split3_old = [];
let orientationChange = false;

let clearTimingLeft = [];

const CardsContainer = forwardRef((props, ref) => {

    const intialBlackjackUseState = {
        isActiveWindowsMode: props.isActiveWindowsMode,
        isActivePortraitMode: props.isActivePortraitMode,
        isActiveLandscapeMode: props.isActiveLandscapeMode,

        backjackChildMainContainer: null,
        bjDealerUlContainer: null,
        bjPlayerUlContainer: null,
        bjdealerli: null,
        bjplayerli: null,
        dealerPlayerScoreBoard: null,
        playerFirstHand: null,
        bjPlayerUlContainerSplit1: null,
        bjPlayerUlContainerSplit2: null,
        bjPlayerUlContainerSplit3: null,
    };



    const [intialState, setIntialState] = useState({ ...intialBlackjackUseState });
    const [gameState, setGamestate] = useState({});
    const [cardDropSound, setCardDropSound] = useState({});

    const [dealCards, setDealCards] = useState([]);


    const [playerCards, setPlayerCards] = useState([]);
    const [playerSplit1Cards, setPlayerFirstSplitCards] = useState([]);
    const [playerSplit2Cards, setPlayerSecondSplitCards] = useState([]);
    const [playerSplit3Cards, setPlayerThirdSplitCards] = useState([]);


    const [dealerScore, setDealerScore] = useState();

    const [playerScore, setPlayerScore] = useState();
    const [playerSplit1Score, setPlayerSplit1Score] = useState();
    const [playerSplit2Score, setPlayerSplit2Score] = useState();
    const [playerSplit3Score, setPlayerSplit3Score] = useState();


    const [dealerHandStatus, setDealerHandStatus] = useState(null);

    const [playerFirstHandStatus, setPlayerFirstHandStatus] = useState(null);
    const [playerSecondtHandStatus, setPlayerSecondtHandStatus] = useState(null);
    const [playerThirdHandStatus, setPlayerThirdHandStatus] = useState(null);
    const [playerFourthHandStatus, setPlayerFourthHandStatus] = useState(null);


    const carddropsound = useRef(null);
    const playerFirstUiContainer = useRef(null);

    const checkNegativeIndex = useRef(false)

    useEffect(() => {
        handleOrientationChange()
        window.addEventListener("resize", handleResize);
        // carddropsound.current = initializeCardDropSound();
        carddropsound.current = new Howl({ src: [cardsdropping_snd], html5: false, preload: true });

        return () => {
            window.removeEventListener("resize", handleResize);
            clearallsettimeouts();
            carddropsound.current.stop();
            carddropsound.current.unload();
        }


    }, []);



    useEffect(() => {

        // dealCards playerCards playerSplit1Cards playerSplit2Cards playerSplit3Cards
        let intervalGap = 0;
        let dealerCardEndIndex = 0
        if (dealCards.length > 0) {
            dealerCardEndIndex = dealCards.length;
            // dropDealerCard(intervalGap, 0, dealerCardEndIndex, true, gameState);
        }

        if (playerCards.length > 0 && dealCards.length > 0) {
            const playerCardEndIndex = playerCards.length;

            // dropPlayerCard(intervalGap, 0, playerCardEndIndex, 0, true, gameState);
            dropCardsAlternating(intervalGap, 0, playerCardEndIndex, 0, true, gameState, 0, dealerCardEndIndex);



        }
        if (playerSplit1Cards.length > 0 && dealCards.length > 0) {
            const playerCardEndIndex = playerSplit1Cards.length;

            // dropPlayerCard(intervalGap, 0, playerCardEndIndex, 1, true, gameState);
            dropCardsAlternating(intervalGap, 0, playerCardEndIndex, 1, true, gameState, 0, 0);


        }
        if (playerSplit2Cards.length > 0 && dealCards.length > 0) {
            const playerCardEndIndex = playerSplit2Cards.length;
            // dropPlayerCard(intervalGap, 0, playerCardEndIndex, 2, true, gameState);
            dropCardsAlternating(intervalGap, 0, playerCardEndIndex, 2, true, gameState, 0, 0);

        }
        if (playerSplit3Cards.length > 0 && dealCards.length > 0) {
            const playerCardEndIndex = playerSplit3Cards.length;
            // dropPlayerCard(intervalGap, 0, playerCardEndIndex, 3, true, gameState);
            dropCardsAlternating(intervalGap, 0, playerCardEndIndex, 3, true, gameState, 0, 0);

        }

    }, [intialState.isActiveLandscapeMode, intialState.isActivePortraitMode, intialState.isActiveWindowsMode]);

    useEffect(() => {
        if (intialState.isActivePortraitMode) {
            if (props.splitCount > 0) {
                const moveElement = document.getElementById("bjPlayerUlContainer");
                moveElement.classList.add("bjPlayerUlContainerSplit1PrtMove");
            }
        }

    }, [props.splitCount, intialState.isActivePortraitMode,])


    useEffect(() => {
        const bkjkDealerCardContainerElement = document.getElementById("blackjackDealerCardContainer");
        if (intialState.isActivePortraitMode) {

            if (dealCards.length > 0) {
                bkjkDealerCardContainerElement.style.left = `calc(70% - ${dealCards.length * 2.35}%)`;
            }
            if (props.splitCount === 0) {
                if (intialState.isActivePortraitMode) {
                    playerFirstUiContainer.current.style.left = `calc(50% - ${playerCards.length * 2.35}%)`;
                }
            }


        } else {

            if (dealCards.length > 0) {
                bkjkDealerCardContainerElement.style.left = `calc(70% - ${dealCards.length * 1.67}%)`;
            }
            if (props.splitCount === 0) {
                playerFirstUiContainer.current.style.left = `calc(50% - ${playerCards.length * 1.67}%)`;
            }


        }







    }, [orientationChange])

    const clearallsettimeouts = () => {

        clearTimingLeft.forEach((timeoutId) => {
            if (timeoutId) {
                clearTimeout(timeoutId)
            }
        })

        clearTimingLeft = [];
    }


    const initializeCardDropSound = () => {
        carddropsound.current = new Howl({
            src: [cardsdropping_snd],
            html5: true, // Enable HTML5 Audio for mobile compatibility
        });

        setCardDropSound((prevState) => ({
            ...prevState, carddropsound: carddropsound.current,
            isCardDropSound: false
        }))

        return carddropsound.current

    }

    const playPokerCardDropSound = (chipSound) => {

        const { isSoundOn } = props
        // let currentSound = chipSound;
        // if (isSoundOn) {

        //     if (currentSound) {
        //         chipSound.stop();
        //     }
        //     if (!chipSound) {
        //         currentSound = this.initializeCardDropSound();
        //     }

        //     currentSound.play();
        //     setCardDropSound((prevState) => ({
        //         isCardDropSound: true
        //     }))

        // }

        if (!isSoundOn)
            return;
        if (isSoundOn) {
            chipSound.stop();
            chipSound.play();
        }

    };


    const handleResize = () => {
        handleOrientationChange()
    }


    const handleOrientationChange = () => {
        orientationChange = !orientationChange
        const isActiveWindowsMode = (navigator.userAgentData && navigator.userAgentData.platform && navigator.userAgentData.platform === "Windows") ||
            (navigator.userAgent.indexOf("Windows") !== -1) || (navigator.platform.includes("Mac") && !("ontouchend" in document || navigator.maxTouchPoints > 0));
        const isActivePortraitMode = window.innerHeight > window.innerWidth;
        const isActiveLandscapeMode = window.innerWidth > window.innerHeight;


        if (isActiveWindowsMode) {
            setIntialState({
                isActiveWindowsMode: isActiveWindowsMode,
                isActivePortraitMode: false,
                isActiveLandscapeMode: false,

                backjackChildMainContainer: "backjackChildMainContainer",
                bjDealerUlContainer: "bjDealerUlContainer",
                bjPlayerUlContainer: "bjPlayerUlContainer",
                bjPlayerUlContainerSplit1: "bjPlayerUlContainer bjPlayerUlContainerSplit1",
                bjPlayerUlContainerSplit2: "bjPlayerUlContainer bjPlayerUlContainerSplit2",
                bjPlayerUlContainerSplit3: "bjPlayerUlContainer bjPlayerUlContainerSplit3",
                bjdealerli: "bjdealerli",
                bjplayerli: "bjplayerli",
                dealerPlayerScoreBoard: "dealerPlayerScoreBoard",
                // dealerPlayerScoreBoard: "dealerPlayerScoreBoard rotating-border rotating-border--rainbow",
                playerFirstHand: "playerFirstHand",
                // liContainer: jacksrbetterJson.liContainer,
                // cardImage: jacksrbetterJson.cardImage,
                // holdSpan: jacksrbetterJson.holdSpan

            })

        } else if (isActivePortraitMode) {
            setIntialState({
                isActiveWindowsMode: false,
                isActivePortraitMode: isActivePortraitMode,
                isActiveLandscapeMode: false,

                backjackChildMainContainer: "backjackChildMainContainerPrt",
                bjDealerUlContainer: "bjDealerUlContainerPrt",
                bjPlayerUlContainer: props.splitCount > 0 ? "bjPlayerUlContainerPrt bjPlayerUlContainerSplit1PrtMove" : "bjPlayerUlContainerPrt",
                bjPlayerUlContainerSplit1: "bjPlayerUlContainerPrt bjPlayerUlContainerSplit1Prt",
                bjPlayerUlContainerSplit2: "bjPlayerUlContainerPrt bjPlayerUlContainerSplit2Prt",
                bjPlayerUlContainerSplit3: "bjPlayerUlContainerPrt bjPlayerUlContainerSplit3Prt",
                bjdealerli: "bjdealerliPrt",
                bjplayerli: "bjplayerliPrt",
                dealerPlayerScoreBoard: "dealerPlayerScoreBoard dealerPlayerScoreBoardLnd",
                playerFirstHand: "playerFirstHand playerFirstHandLnd",
                // liContainer: jacksrbetterJson.liContainerPrt,
                // cardImage: jacksrbetterJson.cardImage,
                // holdSpan: jacksrbetterJson.holdSpan

            })

        } else {
            setIntialState({
                isActiveWindowsMode: false,
                isActivePortraitMode: false,
                isActiveLandscapeMode: isActiveLandscapeMode,

                backjackChildMainContainer: "backjackChildMainContainer",
                bjDealerUlContainer: "bjDealerUlContainerLnd",
                bjPlayerUlContainer: "bjPlayerUlContainerLnd",
                bjPlayerUlContainerSplit1: "bjPlayerUlContainerLnd bjPlayerUlContainerSplit1Lnd   ",
                bjPlayerUlContainerSplit2: "bjPlayerUlContainerLnd bjPlayerUlContainerSplit2Lnd",
                bjPlayerUlContainerSplit3: "bjPlayerUlContainerLnd bjPlayerUlContainerSplit3Lnd",
                bjdealerli: "bjdealerliPrt",
                bjplayerli: "bjplayerliPrt",
                dealerPlayerScoreBoard: "dealerPlayerScoreBoard dealerPlayerScoreBoardLnd",
                playerFirstHand: "playerFirstHand playerFirstHandLnd",
                // liContainer: jacksrbetterJson.liContainerPrt,
                // cardImage: jacksrbetterJson.cardImage,
                // holdSpan: jacksrbetterJson.holdSpan

            })
        }
    }


    useEffect(() => {
        console.log(dealCards, playerCards);
    }, [dealCards, playerCards]);

    useImperativeHandle(ref, () => ({


        blackjacksRespose(res) {
            setGamestate(res)
            switch (res.action) {

                case "PARAM_BET":
                    paramBetResponseAction(res);

                    break;
                case "MOVE_BET":
                    moveBetResponseAction(res);
                    break;

                default:
                    break
            }


        },

        handleGameStateFn(res) {

            setGamestate(res)


            const { dealerCard: dealerCards1, playerCards: playerCards1 } = accessDealerPlayerCardsFn(res.dealerCards, res.playerCards);

            setDealCards([...dealerCards1])
            setPlayerCards([...playerCards1])

            dealerCard_old = [...dealerCards1]
            playerCards_old = [...playerCards1];


            let playerCardStartIndex = 0;
            let dealerCardEndIndex = dealerCards1.length;
            let playerCardEndIndex = playerCards1.length;
            let intervalGap = 50 // 100

            if (playerFirstUiContainer.current) {
                if (intialState.isActivePortraitMode) {
                    playerFirstUiContainer.current.style.left = `calc(50% - ${res.playerCards.length * 2.35}%)`;
                } else {
                    playerFirstUiContainer.current.style.left = `calc(50% - ${res.playerCards.length * 1.67}%)`;
                }
            }

            // dropDealerCard(intervalGap, playerCardStartIndex, dealerCardEndIndex, true, res); // intervalGap, startIndex, endIndex, refreshStatus, response
            // dropPlayerCard(intervalGap, playerCardStartIndex, playerCardEndIndex, 0, true, res); //intervalGap, startIndex, endIndex, activeHand, refreshStatus, response

            dropCardsAlternating(intervalGap, playerCardStartIndex, playerCardEndIndex, 0, true, res, playerCardStartIndex, dealerCardEndIndex);

            if (res?.playerSplitFirstCards?.length > 0) {
                const { dealerCard: dealerCards2, playerCards: playerCards2 } = accessDealerPlayerCardsFn(res.dealerCards, res.playerSplitFirstCards);
                setPlayerFirstSplitCards(playerCards2)
                playerCards_split1_old = [...playerCards2]
                let playerCardFirstSplitEndIndex = playerCards2.length;
                // dropPlayerCard(intervalGap, playerCardStartIndex, playerCardFirstSplitEndIndex, 1, true, res); //intervalGap, startIndex, endIndex, activeHand, refreshStatus, response
                dropCardsAlternating(intervalGap, playerCardStartIndex, playerCardFirstSplitEndIndex, 1, true, res, 0, 0);
            }

            if (res?.playerSplitSecondCards?.length > 0) {
                const { dealerCard: dealerCards3, playerCards: playerCards3 } = accessDealerPlayerCardsFn(res.dealerCards, res.playerSplitSecondCards);
                setPlayerSecondSplitCards(playerCards3)
                playerCards_split2_old = [...playerCards3]
                let playerCardSecondSplitEndIndex = playerCards3.length;
                // dropPlayerCard(intervalGap, playerCardStartIndex, playerCardSecondSplitEndIndex, 2, true, res); //intervalGap, startIndex, endIndex, activeHand, refreshStatus, response
                dropCardsAlternating(intervalGap, playerCardStartIndex, playerCardSecondSplitEndIndex, 2, true, res, 0, 0);
            }
            if (res?.playerSplitThirdCards?.length > 0) {
                const { dealerCard: dealerCards4, playerCards: playerCards4 } = accessDealerPlayerCardsFn(res.dealerCards, res.playerSplitThirdCards);
                setPlayerThirdSplitCards(dealerCards4)
                playerCards_split3_old = [...playerCards4]
                let playerCardThirdSplitEndIndex = playerCards4.length;
                // dropPlayerCard(intervalGap, playerCardStartIndex, playerCardThirdSplitEndIndex, 3, true, res); //intervalGap, startIndex, endIndex, activeHand, refreshStatus, response
                dropCardsAlternating(intervalGap, playerCardStartIndex, playerCardThirdSplitEndIndex, 3, true, res, 0, 0);
            }

        },

        clearCardsForNextRound() {
            dealerCard_old = [];
            playerCards_old = [];

            playerCards_split1_old = [];
            playerCards_split2_old = [];
            playerCards_split3_old = [];

            setDealCards([]);
            setPlayerCards([]);
            setPlayerFirstSplitCards([]);
            setPlayerSecondSplitCards([]);
            setPlayerThirdSplitCards([]);


            setDealerScore(0);

            setPlayerScore(0);
            setPlayerSplit1Score(0);
            setPlayerSplit2Score(0);
            setPlayerSplit3Score(0);


            setDealerHandStatus(null);

            setPlayerFirstHandStatus(null);
            setPlayerSecondtHandStatus(null);
            setPlayerThirdHandStatus(null);
            setPlayerFourthHandStatus(null);

            checkNegativeIndex.current = false;



            const moveElement = document.getElementById("bjPlayerUlContainer");
            if (moveElement?.classList?.contains("bjPlayerUlContainerSplit1PrtMove")) {
                moveElement.classList.remove("bjPlayerUlContainerSplit1PrtMove")
            }


        }


    }))

    // const dropDealerCard = (intervalGap, startIndex, endIndex, refresh, res) => {
    //     let animateCard = startIndex;
    //     const breakIntercal = setInterval(() => {
    //         if (animateCard < endIndex) {
    //             playPokerCardDropSound(carddropsound.current);
    //             moveBKDealerCards(animateCard, refresh)
    //             animateCard++
    //         } else {
    //             clearInterval(breakIntercal)
    //         }


    //     }, ((1 + startIndex) * intervalGap));

    // }

    // const dropPlayerCard = (intervalGap, startIndex, endIndex, activeHand, refresh, res) => {
    //     let animatePlayerCard = startIndex;
    //     const breakPlayerCardInterval = setInterval(() => {
    //         if (animatePlayerCard < endIndex) {
    //             playPokerCardDropSound(carddropsound.current);
    //             moveBKPlayerCards(animatePlayerCard, activeHand, refresh) 
    //             animatePlayerCard++
    //         } else {
    //             clearInterval(breakPlayerCardInterval);
    //             clearTimingLeft.push(
    //                 setTimeout(() => {

    //                     updatePlayerDealerScoreFn(res);
    //                 }, 500))

    //         }
    //     }, ((1 + startIndex) * intervalGap));

    // }



    const dropCardsAlternating = (intervalGap, playerIndexStart, playerIndexEnd, activeHand, refresh, res, dealerIndexStart, dealerIndexEnd) => {
        let turn = "player"; // start with player

        const dropNext = () => {
            if (playerIndexStart < playerIndexEnd || dealerIndexStart < dealerIndexEnd) {
                // if (intervalGap !== 0 && intervalGap !== 50) {
                //     playPokerCardDropSound(carddropsound.current);
                // }

                if (turn === "player" && playerIndexStart < playerIndexEnd) {
                    moveBKPlayerCards(playerIndexStart, activeHand, refresh);
                    playPokerCardDropSound(carddropsound.current);
                    playerIndexStart++;
                    turn = "dealer"; // next turn dealer
                } else if (turn === "dealer" && dealerIndexStart < dealerIndexEnd) {
                    moveBKDealerCards(dealerIndexStart, refresh);
                    playPokerCardDropSound(carddropsound.current);
                    dealerIndexStart++;
                    turn = "player"; // next turn player
                } else {
                    // if one side finished, continue only with the other
                    turn = playerIndexStart < playerIndexEnd ? "player" : "dealer";
                }

                setTimeout(dropNext, intervalGap);
            } else {
                // all cards dealt
                clearTimingLeft.push(
                    setTimeout(() => {
                        updatePlayerDealerScoreFn(res);
                    }, 500)
                );
            }
        };

        dropNext(); // start dealing
    };


    const moveBKDealerCards = (index, refresh = false) => {


        if (intialState.isActiveWindowsMode) {
            // gsap.fromTo(`#bkdealercards${index}`, { x: 950, y: -200, scale: 0.2, autoAlpha: 1, duration: 0.000001 }, { x: index * 50, y: 0, scale: 1, duration: 0.5 });
            gsap.fromTo(`#bkdealercards${index}`, { x: refresh ? 0 : 950, y: refresh ? 0 : -200, scale: refresh ? 1 : 0.2, autoAlpha: 1, duration: 0.000001 },
                { x: index * 50, y: 0, scale: 1, duration: refresh ? 0.0001 : 0.5 });
        } else if (intialState.isActivePortraitMode) {
            gsap.fromTo(`#bkdealercards${index}`, { x: refresh ? 0 : -50, y: refresh ? 0 : -350, scale: refresh ? 1 : 0.2, autoAlpha: 1, duration: 0.000001 },
                { x: index * 65, y: 0, scale: 1, duration: refresh ? 0.0001 : 0.5 });
        } else {
            gsap.fromTo(`#bkdealercards${index}`, { x: refresh ? 0 : 950, y: refresh ? 0 : -200, scale: refresh ? 1 : 0.2, autoAlpha: 1, duration: 0.000001 },
                { x: index * 65, y: 0, scale: 1, duration: refresh ? 0.0001 : 0.5 });

        }
    }

    const moveBKPlayerCards = (index, splitHand, refresh = false) => {

        if (intialState.isActiveWindowsMode) {
            if (index < 6 && splitHand === 0) {
                // gsap.fromTo(`#bkplayercards${index}`, { x: 950, y: -700, scale: 0.2, autoAlpha: 1, duration: 0.000001 }, { x: index * 50, y: 0, scale: 1, duration: 0.5 });
                gsap.fromTo(`#bkplayercards${index}`, { x: 950, y: refresh ? 0 : -600, scale: refresh ? 1 : 0.2, autoAlpha: 1, duration: 0.000001 },
                    { x: index * 50, y: 0, scale: 1, duration: refresh ? 0.0001 : 0.5 });
            } else if (index > 5 && index < 12 && splitHand === 0) {
                // gsap.fromTo(`#bkplayercards${index}`, { x: 950, y: -700, scale: 0.2, autoAlpha: 1, duration: 0.000001 }, { x: (index - 6) * 50, y: 80, scale: 1, duration: 0.5 });
                gsap.fromTo(`#bkplayercards${index}`, { x: 950, y: refresh ? 0 : -650, scale: refresh ? 1 : 0.2, autoAlpha: 1, duration: 0.000001 },
                    { x: (index - 6) * 50, y: 65, scale: 1, duration: refresh ? 0.0001 : 0.5 });


            } else if (index < 6 && splitHand === 1) {
                gsap.fromTo(`#bkplayercardsFirstsplit${index}`, { x: 700, y: refresh ? 0 : -600, scale: refresh ? 1 : 0.2, autoAlpha: 1, duration: 0.000001 },
                    { x: (index * 50), y: 0, scale: 1, duration: refresh ? 0.0001 : 0.5 });
            } else if (index > 5 && index < 12 && splitHand === 1) {
                gsap.fromTo(`#bkplayercardsFirstsplit${index}`, { x: 700, y: refresh ? 0 : -650, scale: refresh ? 1 : 0.2, autoAlpha: 1, duration: 0.000001 },
                    { x: ((index - 6) * 50), y: 65, scale: 1, duration: refresh ? 0.0001 : 0.5 });


            } else if (index < 6 && splitHand === 2) {
                gsap.fromTo(`#bkplayercardsSecondsplit${index}`, { x: 1350, y: refresh ? 0 : -600, scale: refresh ? 1 : 0.2, autoAlpha: 1, duration: 0.000001 },
                    { x: (index * 50), y: 0, scale: 1, duration: refresh ? 0.0001 : 0.5 });
            } else if (index > 5 && index < 12 && splitHand === 2) {
                gsap.fromTo(`#bkplayercardsSecondsplit${index}`, { x: 1350, y: refresh ? 0 : -650, scale: refresh ? 1 : 0.2, autoAlpha: 1, duration: 0.000001 },
                    { x: ((index - 6) * 50), y: 65, scale: 1, duration: refresh ? 0.0001 : 0.5 });


            } else if (index < 6 && splitHand === 3) {
                gsap.fromTo(`#bkplayercardsThirdsplit${index}`, { x: 700, y: refresh ? 0 : -400, scale: refresh ? 1 : 0.2, autoAlpha: 1, duration: 0.000001 },
                    { x: (index * 50), y: 0, scale: 1, duration: refresh ? 0.0001 : 0.5 });
            } else if (index > 5 && index < 12 && splitHand === 2) {
                gsap.fromTo(`#bkplayercardsThirdsplit${index}`, { x: 1350, y: refresh ? 0 : -450, scale: refresh ? 1 : 0.2, autoAlpha: 1, duration: 0.000001 },
                    { x: ((index - 6) * 50), y: 65, scale: 1, duration: refresh ? 0.0001 : 0.5 });
            }




        } else if (intialState.isActivePortraitMode) {

            if (index < 6 && splitHand === 0) {
                // gsap.fromTo(`#bkplayercards${index}`, { x: 0, y: refresh ? 0 : -1400, scale: refresh ? 1 : 0.2, autoAlpha: 1, duration: 0.000001 }, { x: index * 50, y: 0, scale: 1, duration: refresh ? 0.0001 : 0.5 });
                gsap.fromTo(`#bkplayercards${index}`, { x: refresh ? 0 : (props.splitCount > 0 ? 250 : 0), y: refresh ? 0 : -1200, scale: refresh ? 1 : 0.2, autoAlpha: 1, duration: 0.000001 }, { x: index * 65, y: 0, scale: 1, duration: refresh ? 0.0001 : 0.5 });
            } else if (index > 5 && index < 12 && splitHand === 0) {
                gsap.fromTo(`#bkplayercards${index}`, { x: refresh ? 0 : (props.splitCount > 0 ? 250 : 0), y: refresh ? 0 : -1300, scale: refresh ? 1 : 0.2, autoAlpha: 1, duration: 0.000001 }, { x: (index - 6) * 65, y: 80, scale: 1, duration: refresh ? 0.0001 : 0.5 });


            } else if (index < 6 && splitHand === 1) {
                gsap.fromTo(`#bkplayercardsFirstsplit${index}`, { x: refresh ? 0 : (props.splitCount > 0 ? -100 : 0), y: refresh ? 0 : -1200, scale: refresh ? 1 : 0.2, autoAlpha: 1, duration: 0.000001 }, { x: index * 65, y: 0, scale: 1, duration: refresh ? 0.0001 : 0.5 });
            } else if (index > 5 && splitHand === 1) {
                gsap.fromTo(`#bkplayercardsFirstsplit${index}`, { x: refresh ? 0 : (props.splitCount > 0 ? -100 : 0), y: refresh ? 0 : -1300, scale: refresh ? 1 : 0.2, autoAlpha: 1, duration: 0.000001 }, { x: (index - 6) * 65, y: 65, scale: 1, duration: refresh ? 0.0001 : 0.5 });


            } else if (index < 6 && splitHand === 2) {
                gsap.fromTo(`#bkplayercardsSecondsplit${index}`, { x: refresh ? 0 : (props.splitCount > 0 ? -100 : 0), y: refresh ? 0 : -800, scale: refresh ? 1 : 0.2, autoAlpha: 1, duration: 0.000001 }, { x: (index * 65), y: 0, scale: 1, duration: refresh ? 0.0001 : 0.5 });
            } else if (index > 5 && splitHand === 2) {
                gsap.fromTo(`#bkplayercardsSecondsplit${index}`, { x: refresh ? 0 : (props.splitCount > 0 ? -100 : 0), y: refresh ? 0 : -900, scale: refresh ? 1 : 0.2, autoAlpha: 1, duration: 0.000001 }, { x: ((index - 6) * 65), y: 65, scale: 1, duration: refresh ? 0.0001 : 0.5 });

            } else if (index < 6 && splitHand === 3) {
                gsap.fromTo(`#bkplayercardsThirdsplit${index}`, { x: refresh ? 0 : (props.splitCount > 0 ? 250 : 0), y: refresh ? 0 : -800, scale: refresh ? 1 : 0.2, autoAlpha: 1, duration: 0.000001 }, { x: (index * 65), y: 0, scale: 1, duration: refresh ? 0.0001 : 0.5 });
            } else if (index > 5 && splitHand === 3) {
                gsap.fromTo(`#bkplayercardsThirdsplit${index}`, { x: refresh ? 0 : (props.splitCount > 0 ? 250 : 0), y: refresh ? 0 : -900, scale: refresh ? 1 : 0.2, autoAlpha: 1, duration: 0.000001 }, { x: ((index - 6) * 65), y: 65, scale: 1, duration: refresh ? 0.0001 : 0.5 });
            }

        } else {


            if (index < 6 && splitHand === 0) {
                gsap.fromTo(`#bkplayercards${index}`, { x: refresh ? 0 : 950, y: refresh ? 0 : -700, scale: refresh ? 1 : 0.2, autoAlpha: 1, duration: 0.000001 }, { x: index * 65, y: 0, scale: 1, duration: refresh ? 0.0001 : 0.5 });
            } else if (index > 5 && index < 12 && splitHand === 0) {
                gsap.fromTo(`#bkplayercards${index}`, { x: refresh ? 0 : 950, y: refresh ? 0 : -750, scale: refresh ? 1 : 0.2, autoAlpha: 1, duration: 0.000001 }, { x: (index - 6) * 65, y: 80, scale: 1, duration: refresh ? 0.0001 : 0.5 });



            } else if (index < 6 && splitHand === 1) {
                // alert(index)
                gsap.fromTo(`#bkplayercardsFirstsplit${index}`, { x: refresh ? 0 : 550, y: refresh ? 0 : -700, scale: refresh ? 1 : 0.2, autoAlpha: 1, duration: 0.000001 }, { x: index * 65, y: 0, scale: 1, duration: refresh ? 0.0001 : 0.5 });
            } else if (index > 5 && splitHand === 1) {
                gsap.fromTo(`#bkplayercardsFirstsplit${index}`, { x: refresh ? 0 : 550, y: refresh ? 0 : -750, scale: refresh ? 1 : 0.2, autoAlpha: 1, duration: 0.000001 }, { x: (index - 6) * 65, y: 65, scale: 1, duration: refresh ? 0.0001 : 0.5 });



            } else if (index < 6 && splitHand === 2) {
                gsap.fromTo(`#bkplayercardsSecondsplit${index}`, { x: refresh ? 0 : 1400, y: refresh ? 0 : -700, scale: refresh ? 1 : 0.2, autoAlpha: 1, duration: 0.000001 }, { x: (index * 65), y: 0, scale: 1, duration: refresh ? 0.0001 : 0.5 });
            } else if (index > 5 && splitHand === 2) {
                gsap.fromTo(`#bkplayercardsSecondsplit${index}`, { x: refresh ? 0 : 1400, y: refresh ? 0 : -750, scale: refresh ? 1 : 0.2, autoAlpha: 1, duration: 0.000001 }, { x: (index - 6) * 65, y: 65, scale: 1, duration: refresh ? 0.0001 : 0.5 });


            } else if (index < 6 && splitHand === 3) {
                gsap.fromTo(`#bkplayercardsThirdsplit${index}`, { x: refresh ? 0 : 550, y: refresh ? 0 : -400, scale: refresh ? 1 : 0.2, autoAlpha: 1, duration: 0.000001 }, { x: (index * 65), y: 0, scale: 1, duration: refresh ? 0.0001 : 0.5 });
            } else if (index > 5 && splitHand === 3) {
                gsap.fromTo(`#bkplayercardsThirdsplit${index}`, { x: refresh ? 0 : 550, y: refresh ? 0 : -450, scale: refresh ? 1 : 0.2, autoAlpha: 1, duration: 0.000001 }, { x: (index - 6) * 65, y: 65, scale: 1, duration: refresh ? 0.0001 : 0.5 });
            }


        }


    }

    const accessDealerPlayerCardsFn = (dealerCardsRes, playerCardsRes) => {

        const dealerCard = [];
        const playerCards = [];

        const bkjkDealerCardContainerElement = document.getElementById("blackjackDealerCardContainer");

        for (let i = 0; i < dealerCardsRes.length; i++) {

            const cardValue = dealerCardsRes[i];
            if (cardValue === "-1") {
                dealerCard.push({ rsc_val: dealerCardsRes[i], src: emtyCard })
            } else {

                const matchCard = resultCards.find(card => card.rsc_val === cardValue)
                dealerCard.push(matchCard);

            }


        }




        for (let p = 0; p < playerCardsRes.length; p++) {

            const cardValue = playerCardsRes[p];
            const matchCard = resultCards.find(card => card.rsc_val === cardValue)
            playerCards.push(matchCard);



        }

        // setDealCards(dealerCard)
        // setPlayerCards(playerCards)

        // dealerCard_old = [...dealerCard]
        // playerCards_old = [...playerCards];

        if (bkjkDealerCardContainerElement) {
            if (intialState.isActivePortraitMode) {
                bkjkDealerCardContainerElement.style.left = `calc(70% - ${dealerCard.length * 2.35}%)`;
            } else {
                bkjkDealerCardContainerElement.style.left = `calc(70% - ${dealerCard.length * 1.67}%)`;
            }

        }

        return {
            dealerCard: dealerCard,
            playerCards: playerCards
        }

    }


    const paramBetResponseAction = (res) => {

        // setPlayerDealCards
        console.log("res.dealerCards", res.dealerCards, "res.playerCards", res.playerCards);

        const { dealerCard, playerCards } = accessDealerPlayerCardsFn(res.dealerCards, res.playerCards);
        const playerIntervalGap = 300;
        // const dealerIntervalGap = 250;
        // const playerIntervalGap = 250;
        // const dealerIntervalGap = 350;
        let playerStartIndex = 0;

        let totalPlayerCardLength = playerCards.length;
        let dealerCardEndIndex = dealerCard.length;

        setDealCards([...dealerCard])
        setPlayerCards([...playerCards])

        dealerCard_old = [...dealerCard]
        playerCards_old = [...playerCards];

        let animateCard = 0;
        // const breakIntercal = setInterval(() => {
        //     if (animateCard < dealerCard.length) {
        //         moveBKDealerCards(animateCard, false)
        //         animateCard++
        //     } else {
        //         clearInterval(breakIntercal)
        //     }


        // }, 350);
        if (playerFirstUiContainer.current) {
            if (intialState.isActivePortraitMode) {
                playerFirstUiContainer.current.style.left = `calc(50% - ${res.playerCards.length * 2.35}%)`;
            } else {
                playerFirstUiContainer.current.style.left = `calc(50% - ${res.playerCards.length * 1.67}%)`;
            }
        }


        // dropDealerCard(dealerIntervalGap, playerStartIndex, dealerCardEndIndex, 0, false, res); //intervalGap ,startIndex, endIndex, activeHand, refreshStatus, response



        // let animatePlayerCard = 0;


        // dropPlayerCard(playerIntervalGap, playerStartIndex, totalPlayerCardLength, 0, false, res); //intervalGap, startIndex, endIndex, activeHand, refreshStatus, response
        dropCardsAlternating(playerIntervalGap, playerStartIndex, totalPlayerCardLength, 0, false, res, playerStartIndex, dealerCardEndIndex);
        //   const breakPlayerCardInterval = setInterval(() => {
        //     if (animatePlayerCard < playerCards.length) {
        //         // if (animatePlayerCard < 12) {
        //         moveBKPlayerCards(animatePlayerCard, 0, false) //cardStartIndex, activeHand, refreshStatus
        //         animatePlayerCard++
        //     } else {
        //         clearInterval(breakPlayerCardInterval);

        //         clearTimingLeft.push(
        //             setTimeout(() => {
        //                 updatePlayerDealerScoreFn(res);
        //             }, 250)
        //         )
        //     }

        //     // }, 750);
        // }, 250);

        console.log(dealerCard, playerCards)



    }


    const dealerHandUniqueCards = (dealerCards, dealerCardsOld) => {
        console.log("dealerCards", dealerCards)
        console.log("dealerCardsOld", dealerCardsOld)
        const dealerCardNew = dealerCards
            .filter(cardVal => (cardVal !== "-1") && !dealerCardsOld.some(old => (old.rsc_val === cardVal)))
            .map(cardVal => resultCards.find(card => (card.rsc_val === cardVal)));

        return dealerCardNew
    }
    const playerHandUniqueCards = (playerCards, playerCardsOld) => {
        const playerCardsNew = playerCards
            .filter(cardVal => !playerCardsOld.some(old => old.rsc_val === cardVal))
            .map(cardVal => resultCards.find(card => card.rsc_val === cardVal));

        return playerCardsNew

    }



    const moveBetResponseAction = (res) => {

        // const dealerCard = [];
        // const playerCards = [];
        const bkjkDealerCardContainerElement = document.getElementById("blackjackDealerCardContainer");

        const playerIntervalGap = 300;
        const dealerIntervalGap = 350;

        let totalNewCards = 0;
        let totalPlayerCardLength = 0;
        let playerStartIndex = 0;

        let playerCardsNew = []

        // setDealCards((prev) => ([...prev, ...dealerCardNew]));
        const dealerCardNew = dealerHandUniqueCards(res.dealerCards, dealerCard_old);
        const backCardElement = document.getElementById("bkdealercards1");

        checkNegativeIndex.current = res.dealerCards.some((card) => card === "-1");
        let dealerStartIndex = dealerCard_old.length;
        const totalDealerCardLength = dealerCard_old.length + dealerCardNew.length;

        if (checkNegativeIndex.current) {
            setDealCards((prev) => ([...prev, ...dealerCardNew]));
        } else {
            let removedItem = dealerCardNew.shift();
            setDealCards((prev) => ([...prev, ...dealerCardNew]));
            // let tl = gsap.timeline()
            setTimeout(() => {

                setDealCards((prev) => {
                    const updated = [...prev];
                    updated.splice(1, 1, removedItem);
                    return updated
                });
                if (backCardElement) {
                    gsap.fromTo(backCardElement, { rotateY: 90, duration: 0.3, ease: "power1.out" }, { rotateY: 0, duration: 0.25, ease: "power1.out" });
                    // tl.to(backCardElement, { rotateY: 0, duration: 0.25, ease: "power1.out" });
                }
            }, 500)
        }




        // console.log(totalDealerCardLength, dealerCard_old, dealerCardNew)
        if (bkjkDealerCardContainerElement) {
            if (intialState.isActivePortraitMode) {
                bkjkDealerCardContainerElement.style.left = `calc(70% - ${checkNegativeIndex.current ? totalDealerCardLength * 2.35 : (totalDealerCardLength - 1) * 2.35}%)`;
            } else {
                bkjkDealerCardContainerElement.style.left = `calc(70% - ${checkNegativeIndex.current ? totalDealerCardLength * 1.67 : (totalDealerCardLength - 1) * 1.67}%)`;
            }
        }

        switch (res.strType) {
            case "Double":
            case "Hit":
            case "Stand":
                // const playerIntervalGap = 300;
                // const dealerIntervalGap = 350;

                // let totalNewCards = 0;
                // let totalPlayerCardLength = 0;
                // let playerStartIndex = 0;

                // let playerCardsNew = []

                // // setDealCards((prev) => ([...prev, ...dealerCardNew]));
                // const dealerCardNew = dealerHandUniqueCards(res.dealerCards, dealerCard_old);
                // const backCardElement = document.getElementById("bkdealercards1");

                // checkNegativeIndex.current = res.dealerCards.some((card) => card === "-1");
                // let dealerStartIndex = dealerCard_old.length;
                // const totalDealerCardLength = dealerCard_old.length + dealerCardNew.length;

                // // if (checkNegativeIndex.current) {
                // //     setDealCards((prev) => ([...prev, ...dealerCardNew]));
                // // } else {
                // //     if (backCardElement) {
                // //         gsap.to(backCardElement, { rotateY: 90, duration: 0.3, ease: "power1.out" });
                // //     }
                // //     setTimeout(() => {
                // //         setDealCards((prev) => ([...prev.slice(0, -1), ...dealerCardNew]));
                // //         if (backCardElement) {
                // //             gsap.to(backCardElement, { rotateY: 0, duration: 0.25, ease: "power1.out" });
                // //         }
                // //     }, 500)
                // // }

                // if (checkNegativeIndex.current) {
                //     setDealCards((prev) => ([...prev, ...dealerCardNew]));
                // } else {
                //     let removedItem = dealerCardNew.shift();
                //     setDealCards((prev) => ([...prev, ...dealerCardNew]));
                //     // let tl = gsap.timeline()
                //     setTimeout(() => {

                //         setDealCards((prev) => {
                //             const updated = [...prev];
                //             updated.splice(1, 1, removedItem);
                //             return updated
                //         });
                //         if (backCardElement) {
                //             gsap.fromTo(backCardElement, { rotateY: 90, duration: 0.3, ease: "power1.out" }, { rotateY: 0, duration: 0.25, ease: "power1.out" });
                //             // tl.to(backCardElement, { rotateY: 0, duration: 0.25, ease: "power1.out" });
                //         }
                //     }, 500)
                // }




                // // console.log(totalDealerCardLength, dealerCard_old, dealerCardNew)
                // if (bkjkDealerCardContainerElement) {
                //     if (intialState.isActivePortraitMode) {
                //         bkjkDealerCardContainerElement.style.left = `calc(70% - ${checkNegativeIndex.current ? totalDealerCardLength * 2.35 : (totalDealerCardLength - 1) * 2.35}%)`;
                //     } else {
                //         bkjkDealerCardContainerElement.style.left = `calc(70% - ${checkNegativeIndex.current ? totalDealerCardLength * 1.67 : (totalDealerCardLength - 1) * 1.67}%)`;
                //     }
                // }


                // dropDealerCard(dealerIntervalGap, dealerStartIndex, totalDealerCardLength, false, res); // intervalGap, startIndex, endIndex, refreshStatus, response

                // playerCards_split1_old = [];
                // playerCards_split2_old = [];
                // playerCards_split3_old = [];


                // setPlayerFirstSplitCards([]);
                // setPlayerSecondSplitCards([]);
                // setPlayerThirdSplitCards([]);


                switch (props.activeHand) {
                    case 0:
                        // alert("0")
                        playerCardsNew = playerHandUniqueCards(res.playerCards, playerCards_old);
                        setPlayerCards((prev) => ([...prev, ...playerCardsNew]));
                        totalNewCards = dealerCardNew.length + playerCardsNew.length
                        playerStartIndex = playerCards_old.length;
                        totalPlayerCardLength = playerCards_old.length + playerCardsNew.length;

                        // dropPlayerCard(playerIntervalGap, playerStartIndex, totalPlayerCardLength, 0, false, res); //intervalGap, startIndex, endIndex, activeHand, refreshStatus, response

                        dropCardsAlternating(playerIntervalGap, playerStartIndex, totalPlayerCardLength, 0, false, res, dealerStartIndex, checkNegativeIndex.current ? totalDealerCardLength : totalDealerCardLength - 1);

                        if (intialState.isActivePortraitMode) {
                            playerFirstUiContainer.current.style.left = `calc(50% - ${res.playerCards.length * 2.35}%)`;
                        } else {
                            playerFirstUiContainer.current.style.left = `calc(50% - ${res.playerCards.length * 1.67}%)`;
                        }
                        clearTimingLeft.push(
                            setTimeout(() => {
                                playerCards_old = [...playerCards_old, ...playerCardsNew];
                                //   }, 2500)
                            }, totalNewCards * 500)
                        )

                        break;
                    case 1:
                        // alert("1")
                        playerCardsNew = playerHandUniqueCards(res.playerSplitFirstCards, playerCards_split1_old);
                        setPlayerFirstSplitCards((prev) => ([...prev, ...playerCardsNew]));
                        console.log(playerSplit1Cards, playerCardsNew)
                        totalNewCards = dealerCardNew.length + playerCardsNew.length
                        playerStartIndex = playerCards_split1_old.length;
                        totalPlayerCardLength = playerCards_split1_old.length + playerCardsNew.length;

                        // dropPlayerCard(playerIntervalGap, playerStartIndex, totalPlayerCardLength, 1, false, res); //intervalGap, startIndex, endIndex, activeHand, refreshStatus, response

                        dropCardsAlternating(playerIntervalGap, playerStartIndex, totalPlayerCardLength, 1, false, res, dealerStartIndex, checkNegativeIndex.current ? totalDealerCardLength : totalDealerCardLength - 1);
                        clearTimingLeft.push(
                            setTimeout(() => {
                                playerCards_split1_old = [...playerCards_split1_old, ...playerCardsNew];
                                //   }, 2500)
                            }, totalNewCards * 500)
                        )

                        break;
                    case 2:
                        playerCardsNew = playerHandUniqueCards(res.playerSplitSecondCards, playerCards_split2_old);
                        setPlayerSecondSplitCards((prev) => ([...prev, ...playerCardsNew]));
                        totalNewCards = dealerCardNew.length + playerCardsNew.length
                        playerStartIndex = playerCards_split2_old.length;
                        totalPlayerCardLength = playerCards_split2_old.length + playerCardsNew.length;

                        // dropPlayerCard(playerIntervalGap, playerStartIndex, totalPlayerCardLength, 2, false, res); //intervalGap, startIndex, endIndex, activeHand, refreshStatus, response
                        dropCardsAlternating(playerIntervalGap, playerStartIndex, totalPlayerCardLength, 2, false, res, dealerStartIndex, checkNegativeIndex.current ? totalDealerCardLength : totalDealerCardLength - 1);
                        clearTimingLeft.push(
                            setTimeout(() => {
                                playerCards_split2_old = [...playerCards_split2_old, ...playerCardsNew];
                                //   }, 2500)
                            }, totalNewCards * 500)
                        )
                        break;
                    case 3:
                        playerCardsNew = playerHandUniqueCards(res.playerSplitThirdCards, playerCards_split3_old);
                        setPlayerThirdSplitCards((prev) => ([...prev, ...playerCardsNew]));
                        totalNewCards = dealerCardNew.length + playerCardsNew.length
                        playerStartIndex = playerCards_split3_old.length;
                        totalPlayerCardLength = playerCards_split3_old.length + playerCardsNew.length;

                        // dropPlayerCard(playerIntervalGap, playerStartIndex, totalPlayerCardLength, 3, false, res); //intervalGap, startIndex, endIndex, activeHand, refreshStatus, response
                        dropCardsAlternating(playerIntervalGap, playerStartIndex, totalPlayerCardLength, 3, false, res, dealerStartIndex, checkNegativeIndex.current ? totalDealerCardLength : totalDealerCardLength - 1);
                        clearTimingLeft.push(
                            setTimeout(() => {
                                playerCards_split3_old = [...playerCards_split3_old, ...playerCardsNew];
                                //   }, 2500)
                            }, totalNewCards * 500)
                        )
                        break;
                    default:
                        break
                }


                clearTimingLeft.push(
                    setTimeout(() => {
                        if (checkNegativeIndex.current) {
                            dealerCard_old = [...dealerCard_old, ...dealerCardNew]
                        } else {
                            dealerCard_old = [...dealerCard_old.filter((eachCard) => eachCard.rsc_val !== "-1"), ...dealerCardNew]
                        }


                    }, totalNewCards * 500)
                )


                break;

            case "Split":
                let intervalGap = 250;
                let intervalGapFirstSplit = 300;

                let hand1 = [];
                let hand2 = [];
                let lastCard = null;

                // const [playerCards, setPlayerCards] = useState([]);
                // const [playerSplit1Cards, setPlayerFirstSplitCards] = useState([]);
                // const [playerSplit2Cards, setPlayerSecondSplitCards] = useState([]);
                // const [playerSplit3Cards, setPlayerThirdSplitCards] = useState([]);


                switch (props.splitCount) {
                    case 1:
                        hand1 = res.playerCards;
                        hand2 = res.playerSplitFirstCards;

                        lastCard = playerCards[playerCards.length - 1];
                        setPlayerFirstSplitCards((prev) => [...prev, lastCard]);
                        playerCards_split1_old.push(lastCard)
                        clearTimingLeft.push(
                            setTimeout(() => {
                                const el = document.getElementById("bkplayercardsFirstsplit0");
                                if (el) {
                                    // gsap.fromTo(el, { x: -250, y: 0, scale: 1, autoAlpha: 1, duration: 0.000001, }, { x: (0 * 40), y: 0, scale: 1, duration: 0.5 })
                                    moveBKPlayerCards(0, 1, true) //cardStartIndex, activeHand, refreshStatus

                                }
                                setPlayerCards((prev) => prev.slice(0, -1)); // remove last card immutably
                                playerCards_old.pop();

                            }, 50)
                        );

                        setTimeout(() => {
                            const playerFirstHandNewCards = playerHandUniqueCards(hand1, playerCards_old);
                            const playerSecondHandNewCards = playerHandUniqueCards(hand2, playerCards_split1_old);


                            setPlayerCards((prev) => ([...prev, ...playerFirstHandNewCards]));
                            setPlayerFirstSplitCards((prev) => ([...prev, ...playerSecondHandNewCards]));

                            const totalNewCards = playerSecondHandNewCards.length + playerFirstHandNewCards.length

                            let startIndex = playerCards_old.length;
                            const endIndex = playerCards_old.length + playerFirstHandNewCards.length;

                            let startIndexFirstSplit = playerCards_split1_old.length;
                            const endIndexFirstSplit = playerCards_split1_old.length + playerSecondHandNewCards.length;


                            // dropPlayerCard(intervalGap, startIndex, endIndex, 0, false, res); //intervalGap ,startIndex, endIndex, activeHand, refreshStatus, response
                            // dropPlayerCard(intervalGapFirstSplit, startIndexFirstSplit, endIndexFirstSplit, 1, false, res); //intervalGap ,startIndex, endIndex, activeHand, refreshStatus, response

                            dropCardsAlternating(intervalGap, startIndex, endIndex, 0, false, res, 0, 0);
                            clearTimingLeft.push(
                                setTimeout(() => {
                                    dropCardsAlternating(intervalGapFirstSplit, startIndexFirstSplit, endIndexFirstSplit, 1, false, res, dealerStartIndex, checkNegativeIndex.current ? totalDealerCardLength : totalDealerCardLength - 1);
                                }, 350))
                            clearTimingLeft.push(
                                setTimeout(() => {

                                    playerCards_old = [...playerCards_old, ...playerFirstHandNewCards];
                                    playerCards_split1_old = [...playerCards_split1_old, ...playerSecondHandNewCards];
                                    console.log(playerCards_split1_old)

                                }, totalNewCards * 250)
                            )


                        }, 1000);
                        break;
                    case 2:
                        hand1 = res.playerCards;
                        hand2 = res.playerSplitSecondCards;

                        lastCard = playerCards[playerCards.length - 1];
                        setPlayerSecondSplitCards((prev) => [...prev, lastCard]);
                        playerCards_split2_old.push(lastCard)
                        clearTimingLeft.push(
                            setTimeout(() => {
                                const el = document.getElementById("bkplayercardsSecondsplit0");
                                if (el) {
                                    gsap.fromTo(el, { x: 380, y: 0, scale: 1, autoAlpha: 1, duration: 0.000001, }, { x: (0 * 40), y: 0, scale: 1, duration: 0.5 })
                                    moveBKPlayerCards(0, 2, true) //cardStartIndex, activeHand, refreshStatus

                                }
                                setPlayerCards((prev) => prev.slice(0, -1)); // remove last card immutably
                                playerCards_old.pop();

                            }, 50)
                        );

                        setTimeout(() => {
                            const playerFirstHandNewCards = playerHandUniqueCards(hand1, playerCards_old);
                            const playerSecondHandNewCards = playerHandUniqueCards(hand2, playerCards_split2_old);


                            setPlayerCards((prev) => ([...prev, ...playerFirstHandNewCards]));
                            setPlayerSecondSplitCards((prev) => ([...prev, ...playerSecondHandNewCards]));

                            const totalNewCards = playerSecondHandNewCards.length + playerFirstHandNewCards.length

                            let startIndex = playerCards_old.length;
                            const endIndex = playerCards_old.length + playerFirstHandNewCards.length;

                            let startIndexFirstSplit = playerCards_split2_old.length;
                            const endIndexFirstSplit = playerCards_split2_old.length + playerSecondHandNewCards.length;


                            // dropPlayerCard(intervalGap, startIndex, endIndex, 1, false, res); //intervalGap ,startIndex, endIndex, activeHand, refreshStatus, response
                            // dropPlayerCard(intervalGapFirstSplit, startIndexFirstSplit, endIndexFirstSplit, 2, false, res); //intervalGap ,startIndex, endIndex, activeHand, refreshStatus, response

                            dropCardsAlternating(intervalGap, startIndex, endIndex, 1, false, res, 0, 0);
                            clearTimingLeft.push(
                                setTimeout(() => {
                                    dropCardsAlternating(intervalGapFirstSplit, startIndexFirstSplit, endIndexFirstSplit, 2, false, res, dealerStartIndex, checkNegativeIndex.current ? totalDealerCardLength : totalDealerCardLength - 1);
                                }, 350))
                            clearTimingLeft.push(
                                setTimeout(() => {

                                    playerCards_old = [...playerCards_old, ...playerFirstHandNewCards];
                                    playerCards_split2_old = [...playerCards_split2_old, ...playerSecondHandNewCards];

                                }, totalNewCards * 250)
                            )


                        }, 1000);
                        break;
                    case 3:
                        hand1 = res.playerSplitFirstCards;
                        hand2 = res.playerSplitThirdCards;

                        lastCard = playerSplit1Cards[playerSplit1Cards.length - 1];
                        setPlayerThirdSplitCards((prev) => [...prev, lastCard]);
                        playerCards_split3_old.push(lastCard)
                        clearTimingLeft.push(
                            setTimeout(() => {
                                const el = document.getElementById("bkplayercardsThirdsplit0");
                                if (el) {
                                    // gsap.fromTo(el, { x: -250, y: 0, scale: 1, autoAlpha: 1, duration: 0.000001, }, { x: (0 * 40), y: 0, scale: 1, duration: 0.5 })
                                    moveBKPlayerCards(0, 3, true) //cardStartIndex, activeHand, refreshStatus

                                }
                                setPlayerFirstSplitCards((prev) => prev.slice(0, -1)); // remove last card immutably
                                playerCards_split1_old.pop();

                            }, 50)
                        );

                        setTimeout(() => {
                            const playerFirstHandNewCards = playerHandUniqueCards(hand1, playerCards_split1_old);
                            const playerSecondHandNewCards = playerHandUniqueCards(hand2, playerCards_split3_old);


                            setPlayerFirstSplitCards((prev) => ([...prev, ...playerFirstHandNewCards]));
                            setPlayerThirdSplitCards((prev) => ([...prev, ...playerSecondHandNewCards]));

                            const totalNewCards = playerSecondHandNewCards.length + playerFirstHandNewCards.length

                            let startIndex = playerCards_split1_old.length;
                            const endIndex = playerCards_split1_old.length + playerFirstHandNewCards.length;

                            let startIndexFirstSplit = playerCards_split3_old.length;
                            const endIndexFirstSplit = playerCards_split3_old.length + playerSecondHandNewCards.length;


                            // dropPlayerCard(intervalGap, startIndex, endIndex, 2, false, res); //intervalGap ,startIndex, endIndex, activeHand, refreshStatus, response
                            // dropPlayerCard(intervalGapFirstSplit, startIndexFirstSplit, endIndexFirstSplit, 3, false, res); //intervalGap ,startIndex, endIndex, activeHand, refreshStatus, response

                            dropCardsAlternating(intervalGap, startIndex, endIndex, 2, false, res, 0, 0);
                            clearTimingLeft.push(
                                setTimeout(() => {
                                    dropCardsAlternating(intervalGapFirstSplit, startIndexFirstSplit, endIndexFirstSplit, 3, false, res, dealerStartIndex, checkNegativeIndex.current ? totalDealerCardLength : totalDealerCardLength - 1);
                                }, 350))
                            clearTimingLeft.push(
                                setTimeout(() => {

                                    playerCards_split1_old = [...playerCards_split1_old, ...playerFirstHandNewCards];
                                    playerCards_split3_old = [...playerCards_split3_old, ...playerSecondHandNewCards];

                                }, totalNewCards * 250)
                            )


                        }, 1000);
                        break;

                    default:
                        break;
                }
                break


            default:
                break;
        }
    }

    const updatePlayerDealerScoreFn = (res) => {

        setDealerScore(res.dealerScore);

        setPlayerScore(res.playerScore);
        setPlayerSplit1Score(res.playerSplitFirstScore ? res.playerSplitFirstScore : 0);
        setPlayerSplit2Score(res.playerSplitSecondScore ? res.playerSplitSecondScore : 0)
        setPlayerSplit3Score(res.playerSplitThirdScore ? res.playerSplitThirdScore : 0)

        if (res.dealerState !== undefined) {
            setDealerHandStatus(res.dealerState);
        };
        // console.log("res.playerState", res.playerState,  res.playerState !== undefined);
        // console.log("res.dealerState", res.dealerState, res.dealerState !==undefined );

        if ((res.playerState !== undefined)&&(res.dealerState !== undefined)) {
            setPlayerFirstHandStatus(res.playerState)
        };
        if ( (res.playerSplitFirstState !== undefined)&&(res.dealerState !== undefined)) {
            setPlayerSecondtHandStatus(res.playerSplitFirstState);
        };
        if ((res.playerSplitSecondState !== undefined)&&(res.dealerState !== undefined)) {
            setPlayerThirdHandStatus(res.playerSplitSecondState);
        };
        if ((res.playerSplitThirdState !== undefined)&&(res.dealerState !== undefined)) {
            setPlayerFourthHandStatus(res.playerSplitThirdState);
        };

    }

    const { activeHand } = props;
    return (
        <div className={intialState.backjackChildMainContainer}>
            <ul className={intialState.bjDealerUlContainer} id="blackjackDealerCardContainer">
                {dealerScore > 0 &&
                    <div className={intialState.dealerPlayerScoreBoard}>{dealerScore}</div>
                }
                {((dealerHandStatus != undefined) || (dealerHandStatus != null)) &&
                    <div className={intialState.playerFirstHand}> {dealerHandStatus}</div>
                }
                {dealCards.map(({ rsc_val, src }, index) => {
                    return (<li id={`bkdealercards${index}`} className={intialState.bjdealerli} key={index}>
                        <img className="bj_width_for_img" src={src} alt={`image_index_dealer_${index}`} />
                    </li>
                    )
                })}
            </ul>


            <ul className={intialState.bjPlayerUlContainer} id="bjPlayerUlContainer" ref={playerFirstUiContainer}>
                {playerScore > 0 && activeHand === 0 && <MdKeyboardDoubleArrowRight className="activeHansIndicator" />}
                {playerScore > 0 &&
                    <div className={intialState.dealerPlayerScoreBoard}> {playerScore}</div>
                }
                {((playerFirstHandStatus != undefined) || (playerFirstHandStatus != null)) &&
                    <div className={intialState.playerFirstHand}> {playerFirstHandStatus}</div>
                }
                {playerCards.map(({ rsc_val, src }, index) => {
                    return (<li id={`bkplayercards${index}`} className={intialState.bjplayerli} key={index}>
                        <img className="bj_width_for_img" src={src} alt={`image_index_player_${index}`} />
                    </li>
                    )
                })}
            </ul>

            <ul className={intialState.bjPlayerUlContainerSplit1}>
                {playerSplit1Score > 0 && activeHand === 1 && <MdKeyboardDoubleArrowRight className="activeHansIndicator" />}
                {playerSplit1Score > 0 &&
                    <div className={intialState.dealerPlayerScoreBoard}> {playerSplit1Score}</div>
                }
                {((playerSecondtHandStatus != undefined) || (playerSecondtHandStatus != null)) &&
                    <div className={intialState.playerFirstHand}> {playerSecondtHandStatus}</div>
                }
                {playerSplit1Cards.map(({ rsc_val, src }, index) => {
                    return (<li id={`bkplayercardsFirstsplit${index}`} className={intialState.bjplayerli} key={index}>
                        <img className="bj_width_for_img" src={src} alt={`image_index_player_${index}`} />
                    </li>
                    )
                })}
            </ul>
            <ul className={intialState.bjPlayerUlContainerSplit2}>
                {playerSplit2Score > 0 && activeHand === 2 && <MdKeyboardDoubleArrowRight className="activeHansIndicator" />}
                {playerSplit2Score > 0 &&
                    <div className={intialState.dealerPlayerScoreBoard}> {playerSplit2Score}</div>
                }
                {((playerThirdHandStatus != undefined) || (playerThirdHandStatus != null)) &&
                    <div className={intialState.playerFirstHand}> {playerThirdHandStatus}</div>
                }
                {playerSplit2Cards.map(({ rsc_val, src }, index) => {
                    return (<li id={`bkplayercardsSecondsplit${index}`} className={intialState.bjplayerli} key={index}>
                        <img className="bj_width_for_img" src={src} alt={`image_index_player_${index}`} />
                    </li>
                    )
                })}
            </ul>
            <ul className={intialState.bjPlayerUlContainerSplit3}>
                {playerSplit3Score > 0 && activeHand === 3 && <MdKeyboardDoubleArrowRight className="activeHansIndicator" />}

                {playerSplit3Score > 0 &&
                    <div className={intialState.dealerPlayerScoreBoard}> {playerSplit3Score}</div>
                }

                {((playerFourthHandStatus != undefined) || (playerFourthHandStatus != null)) &&
                    <div className={intialState.playerFirstHand}> {playerFourthHandStatus}</div>
                }

                {playerSplit3Cards.map(({ rsc_val, src }, index) => {
                    return (<li id={`bkplayercardsThirdsplit${index}`} className={intialState.bjplayerli} key={index}>
                        <img className="bj_width_for_img" src={src} alt={`image_index_player_${index}`} />
                    </li>
                    )
                })}
            </ul>




        </div>
    )


})


export default CardsContainer;